<!-- src/components/NotificationBell.vue -->
<template>
  <div class="notification-bell">
    <!-- Unsupported browser -->
    <button
      v-if="!isSupported"
      class="bell-btn disabled"
      disabled
      title="مرورگر شما از نوتیفیکیشن پشتیبانی نمی‌کند"
    >
      <i class="fas fa-bell-slash"></i>
    </button>

    <!-- iOS needs "Add to Home Screen" -->
    <button
      v-else-if="iosNeedsInstall"
      class="bell-btn"
      :disabled="busy"
      title="برای فعال‌سازی، سایت را به صفحه اصلی اضافه کنید"
      @click="showIosHint"
    >
      <i class="fas fa-bell-slash"></i>
    </button>

    <!-- Normal: toggles on/off -->
    <button
      v-else
      class="bell-btn"
      :class="{ active: subscribed }"
      :disabled="busy"
      :title="subscribed ? 'خاموش کردن اعلان‌ها' : 'روشن کردن اعلان‌ها'"
      @click="toggle"
    >
      <i v-if="busy" class="fas fa-spinner fa-spin"></i>
      <i v-else-if="subscribed" class="fas fa-bell"></i>
      <i v-else class="fas fa-bell-slash"></i>
    </button>
  </div>
</template>

<script setup>
import { onMounted, getCurrentInstance } from 'vue'
import { usePushNotifications } from '@/composables/usePushNotifications'

const instance = getCurrentInstance()

function notify(payload) {
  instance.emit('notify', payload)
}

const {
  subscribed,
  busy,
  isSupported,
  iosNeedsInstall,
  subscribe,
  unsubscribe,
  refreshSubscriptionState,
} = usePushNotifications()

async function toggle() {
  try {
    if (subscribed.value) {
      await unsubscribe()
      notify('اعلان‌ها خاموش شد', 'info')
    } else {
      await subscribe()
      notify('اعلان‌ها روشن شد', 'success')
    }
  } catch (e) {
    const msg = e?.message || 'خطا در تغییر وضعیت اعلان'
    if (msg.includes('permission')) {
      notify('اجازه اعلان داده نشد. از تنظیمات مرورگر فعال کنید.', 'error')
    } else {
      notify(msg, 'error')
    }
  }
}

function showIosHint() {
  notify(
    'در iPhone: دکمه اشتراک‌گذاری Safari → Add to Home Screen → سپس اعلان‌ها را فعال کنید.',
    'info'
  )
}

onMounted(() => {
  refreshSubscriptionState()
})
</script>

<style scoped>
.notification-bell {
  display: inline-flex;
  align-items: center;
}

.bell-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  color: var(--text-muted, #888);
  font-size: 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.bell-btn:hover:not(:disabled) {
  transform: scale(1.1);
  color: var(--primary, #6c5ce7);
}

.bell-btn.active {
  color: var(--primary, #6c5ce7);
}

.bell-btn.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>